import { FC } from 'react';

import { useHistoryMovementsView } from '../context/HistoryMovementsViewContext';
import { historyMovementsViewExpandedTableHeaderMap } from '../constants/historyMovementsViewExpandedTableHeaderMap';

const HistoryMovementsViewExpandedTableHeader: FC = () => {
  const { data } = useHistoryMovementsView();

  const HeaderComponent =
    data.operationType &&
    historyMovementsViewExpandedTableHeaderMap[data.operationType];

  return (HeaderComponent && <HeaderComponent />) || null;
};

export default HistoryMovementsViewExpandedTableHeader;
